import React, { Component } from "react";
import PropTypes from "prop-types";
import { connectCurrentRefinements, SearchBox } from "react-instantsearch-dom";
import { debounce } from "lodash";
import classNames from "classnames";

const itemsPropType = PropTypes.arrayOf(
    PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.func.isRequired,
        items: (...args) => itemsPropType(...args)
    })
);

class SearchRow extends Component {
    static propTypes = {
        searchState: PropTypes.shape({
            query: PropTypes.string
        }).isRequired,
        refine: PropTypes.func.isRequired,
        items: itemsPropType
    };

    constructor(props) {
        super(props);

        this.state = {
            focused: false,
            mobile: true
        };

        this.handleResize = debounce(this.handleResize.bind(this), 250);
    }

    handleFocus = () => {
        this.setState({ focused: true });
    };

    handleBlur = () => {
        this.setState({ focused: false });
    };

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);

        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    componentDidUpdate(prevProps) {
        const { searchState, refine, items } = this.props;

        if (
            searchState.query &&
            searchState.query !== prevProps.searchState.query
        ) {
            refine(items);
        }
    }

    handleResize() {
        const mobile = window.matchMedia("(max-width: 992px)").matches;

        this.setState({ mobile });
    }

    render() {
        const { focused, mobile } = this.state;

        const placeholder = mobile
            ? "Search"
            : "Search for a product family, brand, application or category";

        return (
            <div className="search-row">
                <div
                    className={classNames("search-box", {
                        "search-box--focused": focused
                    })}
                >
                    <div className="search-box__label">Search</div>

                    <div className="search-box__input-wrapper">
                        <SearchBox
                            placeholder="Search"
                            searchAsYouType={false}
                            translations={{ placeholder }}
                            onFocus={this.handleFocus}
                            onBlur={this.handleBlur}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default connectCurrentRefinements(SearchRow);



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/SearchRow.js